export default "__VITE_ASSET__4770ae58__"